import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useNavigate} from "react-router-dom";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link, useParams} from "react-router-dom";
import {updateExtension, getCurrentExtension, resetUpdateExtensionStatus} from "../../store/reducers/ExtensionsSlice";
import {RequestStatus} from "../../utils/Enums";
import {getUsers} from "../../store/reducers/UsersSlice";
import ElogSelect, {Option} from "../common/form/ElogSelect";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface ModifyExtensionScreenProps {
}

export interface ModifyExtensionFormProps {
    user: number;
    expires_at: string;
}

export const ModifyExtensionScreen: React.FC<ModifyExtensionScreenProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const {id} = useParams();

    const usersState = useAppSelector((state) => state.users);
    const extensionsState = useAppSelector((state) => state.extensions);
    const requestStatus: RequestStatus = extensionsState.updateExtensionStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Pikendused", url: "/extensions"},
        {text: "Pikenduse muutmine", url: `/extensions/${id}/modify`},
    ];

    useEffect(() => {

        dispatch(getUsers());

        if (id) {
            dispatch(getCurrentExtension({id}));
        }

    }, [id]);

    const userOptions: Option[] = usersState.users
        .filter((user) => user.logistician === 1)
        .map((user) => ({
            value: user.id.toString(),
            label: `${user.firstname} ${user.lastname}`,
        }));

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            user: extensionsState.currentExtension?.user_id ?? userOptions[0]?.value,
            expires_at: extensionsState.currentExtension?.expires_at ?? "",
        },
        onSubmit: (values: any) => {
            if (id) {
                dispatch(updateExtension({id, data: values}));
            }
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success &&
            <div className="message msg-ok">
              <div>
                <h2>Andmed muudetud</h2>
              </div>
            </div>
            }
            {requestStatus === RequestStatus.Failed && extensionsState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {extensionsState.errors.map((error, index) => (
                            <span key={index}>{error}<br/></span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>Pikenduse andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogSelect label="Logistik" name="user" options={userOptions} mandatory={true}/>
                            <ElogInput label="Tunde pikendust" name="expires_at" mandatory={true}/>
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                  <span>
                                    <strong>Muuda</strong>
                                  </span>
                            </button>
                            <Link to="/extensions">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};